import React from "react";

import { defaultLang, t, languages, setLanguage } from "../../i18n";

import type { UserPreferences } from "../../userPreferences";

interface LanguageSettingsProps {
  preferences: UserPreferences;
  onChange: (updates: Partial<UserPreferences>) => void;
}

export const LanguageSettings: React.FC<LanguageSettingsProps> = ({
  preferences,
  onChange,
}) => {
  // Filter out test languages (only shown in dev environment)
  const availableLanguages = languages.filter(
    (lang) => !lang.code.startsWith("__test__"),
  );

  return (
    <div className="LanguageSettings">
      <h3>{t("settings.language")}</h3>
      <p className="LanguageSettings__description">
        {t("settings.languageDescription")}
      </p>
      <div className="LanguageSettings__select">
        <label>{t("settings.selectLanguage")}</label>
        <select
          value={preferences.language || "en"}
          onChange={(e) => {
            const langCode = e.target.value;
            onChange({ language: langCode });
            const lang =
              languages.find((l) => l.code === langCode) ?? defaultLang;
            void setLanguage(lang);
          }}
        >
          {availableLanguages.map((lang) => (
            <option key={lang.code} value={lang.code}>
              {lang.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};
